import React, { Suspense, lazy, useState } from 'react';
import { getCookieByKey } from '../../../common/utilities/cookie';
import { refreshtokenCookieName } from '../../../containers/auth/constants';
import { SignInOutLink } from './signInOutLink';
import { translate } from '../../../common/translation/translate';
import { reduxConnect } from '../../../common';
import type { IStoreState } from '../../common/interfaces/types';
import type { AuthState } from '../../../common/reducers/authReducer';

interface ICurrentStoreState extends IStoreState {
    userAuth: AuthState;
}

type AuthLazyLoadProps = {
    isLargeLink?: boolean;
    isLoggedIn: boolean;
}

type SignInOutLazyProps = Pick<AuthLazyLoadProps, 'isLargeLink'>;
type SignInPopupLazyProps = {
    open: boolean; 
    onClose: () => void; 
}

const SignInOutButton = lazy(() => import('./signInOutButton'));
const SignInPopup = lazy(() => import('./signInPopup'));

const SignInOutLazy = ({ isLargeLink }: SignInOutLazyProps): JSX.Element => {
    return (
        <Suspense fallback={<p>...</p>}>
            <SignInOutButton isLargeLink={isLargeLink} />
        </Suspense>
    );
};

const SignInPopupLazy = ({ open, onClose }: SignInPopupLazyProps): JSX.Element => {
    return (
        <Suspense fallback={<>...</>}>
            <SignInPopup open={open}  onClose={onClose} />
        </Suspense>
    );
};

const mapStoreStateToProps = (storeState: ICurrentStoreState) => {
    const { userAuth } = storeState ?? {};
    const { isLoggedIn } = userAuth ?? {};
    return {
        isLoggedIn
    };
};

const mapDispatchToProps = {};

export const AuthLazyLoad = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({ isLargeLink, isLoggedIn }: AuthLazyLoadProps) => {
    const [userInitiatedAuthentication, setUserInitiatedAuthentication] = useState(false);

    const isAuthenticatedUser = getCookieByKey(refreshtokenCookieName);

    if (!isAuthenticatedUser && !isLoggedIn) {
        return (
            <>
                <SignInOutLink isLargeLink={!!isLargeLink} onClick={() => setUserInitiatedAuthentication(true)}>{ translate('signin') }</SignInOutLink>
                {
                    userInitiatedAuthentication ? <SignInPopupLazy open={true} onClose={()=>setUserInitiatedAuthentication(false)} /> : null
                }
            </>
        );
    }

    return <SignInOutLazy isLargeLink={isLargeLink} />;
});